import { render, staticRenderFns } from "./table-content.vue?vue&type=template&id=5a879be6"
import script from "./table-content.vue?vue&type=script&lang=ts"
export * from "./table-content.vue?vue&type=script&lang=ts"
import style0 from "./table-content.vue?vue&type=style&index=0&id=5a879be6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports